import styled from 'styled-components'
import above from '@/utils/above'
import getColumnSize from '@/utils/getColumnSize'
import * as UI from '@/components/UI'

export const Section = styled.section`
  margin-top: 1.5rem;
  ${above('sm')`
    margin-top: 2rem;
  `}
  ${above('md')`
    margin-top: 4rem;
  `}
  ${above('lg')`
    margin-top: 6.25rem;
  `}
`

export const Grid = styled(UI.Grid)`
  justify-content: center;
`

export const TextCell = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: ${getColumnSize(12)};
  ${above('sm')`
     width: ${getColumnSize(10)};
   `}
  ${above('md')`
    width: ${getColumnSize(8)};
  `}
  ${above('lg')`
    width: ${getColumnSize(6)};
  `}
`

export const ImageWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  position: relative;
  z-index: 100;
  padding: 6em 3em 0;

  & > * {
    margin-right: 1em;
    width: calc(100% / 2 - 1em);

    &:nth-child(2n) {
      transform: translateY(-35%);
    }

    &:nth-child(n + 3) {
      display: none;
    }

    ${above('md')`
      margin-right: 2em;
      width: calc(100% / 4 - 2em);
      display: block !important;
    `}
  }

  &:before {
    content: '';
    position: absolute;
    display: block;
    top: 50%;
    bottom: 0;
    left: 0;
    right: 0;
    background: ${p => p.theme.colors.maastricht};
  }
`
